import { getUser } from './authProvider';

export default (group) => {
  const user = getUser();
  if (!user) return false;
  return !!user.groups.find(({ name }) => name === group);
};
